import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["banner", "suggestedName", "zoneItem", "detectedContainer", "detectedZoneLabel"]
    static values = {
        current: String,
        hasSession: Boolean
    }

    connect() {
        this.detect()
    }

    detect() {
        const detectedZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        if (!detectedZone) return

        this.detectedZone = detectedZone

        if (this.hasDetectedZoneLabelTarget && this.hasDetectedContainerTarget) {
            this.detectedZoneLabelTarget.textContent = detectedZone
            this.detectedContainerTarget.classList.remove('hidden')
        }

        if (detectedZone !== this.currentValue) {
            this.showSuggestion(detectedZone)
        } else {
            this.dismiss()
        }

        this.highlightDetected()
    }

    highlightDetected() {
        if (!this.hasZoneItemTarget) return

        this.zoneItemTargets.forEach(item => {
            if (item.dataset.zoneName === this.detectedZone) {
                const badge = item.querySelector('[data-detected-badge]')
                if (badge) badge.classList.remove('hidden')
            }
        })
    }

    showSuggestion(zone) {
        if (this.hasBannerTarget && this.hasSuggestedNameTarget) {
            const cityName = zone.split('/').pop().replace('_', ' ')
            this.suggestedNameTarget.textContent = cityName
            this.suggestedNameTarget.dataset.zone = zone
            this.bannerTarget.classList.remove('hidden')
            this.bannerTarget.classList.add('flex', 'animate-fade-in')
        }
    }

    applySuggested() {
        if (this.hasSuggestedNameTarget) {
            this.apply(this.suggestedNameTarget.dataset.zone)
        }
    }

    applyDetected() {
        if (this.detectedZone) this.apply(this.detectedZone)
    }

    apply(zone) {
        const url = new URL(window.location.href)
        url.searchParams.set("time_zone", zone)
        window.Turbo.visit(url.toString(), { action: "advance" })
    }

    dismiss() {
        if (this.hasBannerTarget) {
            this.bannerTarget.classList.add('hidden')
            this.bannerTarget.classList.remove('flex')
        }
    }
}


